import { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
const GRID_COLUMNS_FACTOR = 8;
const getTrackOffset = (justify, totalNumberOfTracks, occupiedTracksByTrailingChildren) => {
    switch (justify) {
        case 'center':
            return (totalNumberOfTracks - occupiedTracksByTrailingChildren) / 2;
        case 'end':
            return totalNumberOfTracks - occupiedTracksByTrailingChildren;
        case 'start':
        default:
            return 0;
    }
};
export const getTotalNumberOfTracks = (breakpoint, columns) => {
    if (typeof columns === 'number')
        return columns * GRID_COLUMNS_FACTOR;
    return columns[breakpoint] * GRID_COLUMNS_FACTOR;
};
export const getJustifyStyles = (breakpoint, justify, numberOfTrailingChildren, columns) => {
    const totalNumberOfTracks = getTotalNumberOfTracks(breakpoint, columns);
    const occupiedTracksByTrailingChildren = numberOfTrailingChildren * GRID_COLUMNS_FACTOR;
    const tracksOffset = getTrackOffset(justify, totalNumberOfTracks, occupiedTracksByTrailingChildren);
    return css `
		grid-column: ${tracksOffset + 1} / span ${occupiedTracksByTrailingChildren};
	`;
};
export const getColumnStyles = (columns) => ({ theme }) => {
    switch (typeof columns) {
        case 'number':
            return css `
					@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
						grid-template-columns: repeat(${columns * GRID_COLUMNS_FACTOR}, 1fr);
					}
				`;
        case 'object':
            return css `
					grid-template-columns: repeat(${columns.sm * GRID_COLUMNS_FACTOR}, 1fr);

					@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
						grid-template-columns: repeat(${columns.md * GRID_COLUMNS_FACTOR}, 1fr);
					}

					@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
						grid-template-columns: repeat(${columns.lg * GRID_COLUMNS_FACTOR}, 1fr);
					}
				`;
        default:
            return css ``;
    }
};
//# sourceMappingURL=utilities.styled.js.map